var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryPersonWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M140.78 123.179c10.174-.407 19.142 6.621 21.179 16.596a3.467 3.467 0 01-.708 2.876 2.183 2.183 0 01-2.685.787h-65.4a6.255 6.255 0 01-6.927-6.439v-.043a20.08 20.08 0 00-20.082-20.081H44.03a20.081 20.081 0 00-20.081 20.081v6.97",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M130.156 85h10.625v58.438M66.157 116.875h26.81",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    clipRule: "evenodd",
    d: "M7.969 63.75a5.312 5.312 0 015.312-5.313h31.875a5.313 5.313 0 015.313 5.313v26.563a5.313 5.313 0 01-5.313 5.312H13.281a5.312 5.312 0 01-5.312-5.313V63.75z",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M140.781 93.068l13.565-5.39a6.51 6.51 0 015.164.184 4.122 4.122 0 012.521 3.591v15.888a4.122 4.122 0 01-2.521 3.591 6.51 6.51 0 01-5.164.185l-13.565-5.391",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    clipRule: "evenodd",
    d: "M55.781 164.688c8.802 0 15.938-7.136 15.938-15.938s-7.136-15.938-15.938-15.938-15.937 7.136-15.937 15.938 7.135 15.938 15.937 15.938z",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M120.035 143.402a18.326 18.326 0 00-.503 4.25 15.97 15.97 0 007.646 14.715 15.97 15.97 0 0016.583 0 15.97 15.97 0 007.646-14.715 18.112 18.112 0 00-.503-4.25M29.219 58.438v15.937M124.844 69.063c-28.674-18.7-29.042-20.429-39.121-20.429-7.687-.039-13.954 6.154-14.004 13.841V85c0 5.868 4.757 10.625 10.625 10.625h10.625a21.25 21.25 0 0120.159 14.528l5.78 17.347",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 100,
    cy: 20,
    r: 15,
    strokeWidth: 10
  })));
}
export default SvgDeliveryPersonWhite;